import { useAndStore } from "../../base/store/useAndStore";

export type PdfViewerCommand =
  | "print"
  | "download"
  | "enterFullscreen"
  | "exitFullscreen"
  | "goToPage"
  | "fitWidth"
  | "fitHeight"
  | "zoomIn"
  | "zoomOut"
  | "previewSingle"
  | "previewAll";

/**
 * 通过 propsStore 下发 PDF 查看器指令（与 addCommand 运行时解耦，避免 initRuntime 找不到动作）。
 * 会与已有 propsStore 条目浅合并，避免覆盖其它动态属性。
 */
export function dispatchPdfViewerCommand(
  sessionId: string,
  componentId: string,
  command: PdfViewerCommand,
  arg?: number,
) {
  const { getProps, setProps } = useAndStore.getState();
  const prev = getProps(sessionId, componentId);
  const base =
    prev && typeof prev === "object" && !Array.isArray(prev) ? prev : {};
  setProps(sessionId, componentId, {
    ...base,
    pdfCommand: command,
    pdfCommandArg: arg,
    _pdfCmdNonce: Date.now(),
  });
}
